


// import { shopifyGQL } from 'services' // Removed - hydrogen-react integration removed

import type {
  GetShopProductsPayload,
  GetSingleShopProductByIdPayload,
  ShopProducts
} from './types'

import { call, fork, put, takeLatest } from 'redux-saga/effects'

import { ActionCallback } from '../model'
import { ActionType } from './types'





export function* getShopProductsSaga(): Generator {
  yield takeLatest(ActionType.GET_SHOP_PRODUCTS, function* (action: ActionCallback<GetShopProductsPayload>) {
    const { payload, callback } = action

    const productCatalogQuery = `
query ProductCatalog {
  products(first: 10) {
    nodes {
      id
      title
      productType
      tags
      descriptionHtml
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
      }
      featuredImage {
        id
        width
        height
        url
      }
      variants(first: 10) {
        nodes {
          id
          title
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
}
    `;

    try {
      // TODO: Replace with backend API call when ready
      // const { status, data } = yield call(shopifyGQL, { body: productCatalogQuery });
      console.warn('getShopProductsSaga: Shopify hydrogen-react removed - implement backend API call');
      if (callback) callback()
    } catch (error) {
      console.error(error)
    }
  })
}

export function* getSingleShopProductSaga(): Generator {
  yield takeLatest(ActionType.GET_SINGLE_SHOP_PRODUCT, function* (action: ActionCallback<GetSingleShopProductByIdPayload>) {
    // payload is product ID
    const { payload, callback } = action
    const productQuery = `
      query ProductQuery($id: ID!) {
        product(id: $id) {
          id
          title
          productType
          tags
          descriptionHtml
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
          featuredImage {
            id
            width
            height
            url
          }
          variants(first: 10) {
            nodes {
              id
              title
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    `;

    const shopifyProductId = `gid://shopify/Product/${payload.productId}`;

    try {
      // TODO: Replace with backend API call when ready
      // const { status, data } = yield call(shopifyGQL, { body: productQuery, variables: { id: shopifyProductId } });
      console.warn('getSingleShopProductSaga: Shopify hydrogen-react removed - implement backend API call');
      if (callback) callback()
    } catch (error) {
      console.error(error)
    }
  })
}


export default [
  fork(getShopProductsSaga),
  fork(getSingleShopProductSaga)
]
